import styles from "./Certificados.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Loading from "../../../../components/components-ui/Loading/Loading";
import Button from "../../../../components/components-ui/Button/Button";
import { Table } from "../../../../components/Table";
import { Grid, Col } from "../../../../components/Grid";
import api from "../../../../services/Api";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import {
  customStyles,
  SelectSearch,
} from "../../../../components/components-ui/SelectSearch/SelectSearch";
import Select from "react-select";
import InputClear from "../../../../components/components-ui/InputClear/InputClear";
import { useOrdenacao } from "../../../../utils/useOrdenacao";
import CustomConfirmAlert from "../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";
import { toast } from "react-toastify";
import { Modal } from "@mui/material";
import NovoCertificado from "./Modal/NovoCertificado";
import { AuthContext } from "../../../../Provider/AuthContext";
import { useVerificaPermissao } from "../../../../utils/verificaPermissao";

const API_CERTIFICADOS = "/certificados/index";
const API_STATUS = "/certificados/status/index";
const API_MODELOS = "/certificados/modelos/index";

// Colunas da tabela
const columns = [
  {
    column: "Número Certificado",
    key: "NumeroCertificado",
  },
  {
    column: "Modelo",
    key: "Modelo",
  },
  {
    column: "Status",
    key: "Status",
  },
];

export default function Certificados() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [dadosTabela, setDadosTabela] = useState([]);
  const [status, setStatus] = useState([]);
  const [modelosCertificados, setModelosCertificados] = useState([]);

  const [openModal, setOpenModal] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterTable, setFilterTable] = useState("");

  const { dados, ordenar, ordem, setDados } = useOrdenacao(
    dadosTabela,
    setDadosTabela
  );

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela de certificados
    verificaPermissao(idTipoUsuario, 87);
  }, []);

  const getOptionsSelects = async () => {
    await api
      .get(API_STATUS)
      .then((res) => setStatus(res.data.data))
      .catch((error) => console.log(error));

    await api
      .get(API_MODELOS)
      .then((res) => setModelosCertificados(res.data.data))
      .catch((error) => console.log(error));
  };

  const getCertificados = async () => {
    await api
      .get(API_CERTIFICADOS + `?page=${currentPage}${filterTable}`)
      .then((res) => {
        setTotalPages(res.data.totalPages);
        setCurrentPage(res.data.currentPageNumber);
        setDadosTabela(res.data.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getOptionsSelects();
  }, []);

  useEffect(() => {
    getCertificados();
  }, [currentPage, filterTable]);

  const filter = (values) => {
    let data = `${
      values?.numeroCertificadoDe
        ? `&numero_certificado_de=${values?.numeroCertificadoDe}`
        : ""
    }`;
    data += `${
      values?.numeroCertificadoAte
        ? `&numero_certificado_ate=${values?.numeroCertificadoAte}`
        : ""
    }`;
    data += `${values?.modelo ? `&id_modelo=${values?.modelo}` : ""}`;
    data += `${values?.status ? `&id_status=${values?.status}` : ""}`;

    setCurrentPage(1);
    setFilterTable(data);
  };

  function resetFilters(resetForm, setFieldValue) {
    resetForm();
    setFilterTable("");
    setCurrentPage(1);
  }

  function previewPage() {
    if (currentPage === 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(currentPage - 1);
    }
  }

  function nextPage() {
    if (currentPage === totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(currentPage + 1);
    }
  }

  return (
    <Container>
      <h3>Certificados para Coletas</h3>
      <Button title="Novo" type="button" onClick={() => setOpenModal(true)} />
      <div className={styles.content}>
        <Formik
          initialValues={{
            numeroCertificadoDe: "",
            numeroCertificadoAte: "",
            modelo: null,
            status: null,
          }}
          //   validationSchema={ValidationSchema}
          onSubmit={(values) => filter(values)}
        >
          {({ values, errors, touched, resetForm, setFieldValue }) => (
            <Form>
              <section className={styles.wrap}>
                <div className={styles.filter_header}>
                  <strong>Filtros</strong>
                  <div style={{ display: "flex", gap: 10 }}>
                    <Button title="Procurar" type="submit" />
                    <Button
                      type="button"
                      title="Limpar filtros"
                      color="tertiary"
                      onClick={() => resetFilters(resetForm, setFieldValue)}
                    />
                  </div>
                </div>
                <Grid>
                  <Col size={3}>
                    <label>Nº Certificado De: </label>
                    <Field type="text" name="numeroCertificadoDe">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() =>
                            setFieldValue("numeroCertificadoDe", "")
                          }
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroCertificadoDe &&
                    touched.numeroCertificadoDe ? (
                      <span className={styles.alertError}>
                        {errors.numeroCertificadoDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Nº Certificado Ate: </label>
                    <Field type="text" name="numeroCertificadoAte">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() =>
                            setFieldValue("numeroCertificadoAte", "")
                          }
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroCertificadoAte &&
                    touched.numeroCertificadoAte ? (
                      <span className={styles.alertError}>
                        {errors.numeroCertificadoAte}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Modelo</label>
                    <Field
                      name="modelo"
                      component={SelectSearch}
                      options={modelosCertificados.map((values) => ({
                        label: values?.descricao,
                        value: values?.ID,
                      }))}
                    />
                    {errors.modelo && touched.modelo ? (
                      <span className={styles.alertError}>{errors.modelo}</span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Status</label>
                    <Field
                      name="status"
                      component={SelectSearch}
                      options={status.map((values) => ({
                        label: values?.Status,
                        value: values?.IdStatus,
                      }))}
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                </Grid>
              </section>

              <div className={styles.container_table}>
                <Table columns={columns} onSort={ordenar} ordem={ordem}>
                  {!showLoading
                    ? dados.map((values, index) => (
                        <tr key={values?.IDCertificados}>
                          <td>{values?.NumeroCertificado}</td>
                          <td>{values?.Modelo}</td>
                          <td>{values?.Status}</td>
                        </tr>
                      ))
                    : null}
                </Table>
              </div>
              {dados.length == 0 && !showLoading ? (
                <p style={{ textAlign: "center", marginBottom: "20px" }}>
                  Nenhuma opção encontrada
                </p>
              ) : (
                ""
              )}
              <div className={styles.loading}>
                <Loading display={showLoading ? "block" : "none"} />
              </div>

              <div className={styles.table_pagination}>
                {dados.length ? (
                  <div className={styles.table_pagination_buttons}>
                    <Button
                      disabled={currentPage === 1 ? true : false}
                      onClick={() => previewPage()}
                      type="button"
                    >
                      <i
                        style={{ marginRight: 5 }}
                        className="fas fa-chevron-left"
                      ></i>
                      Voltar
                    </Button>
                    <span>
                      {currentPage} De {totalPages}
                    </span>
                    <Button
                      disabled={
                        currentPage === totalPages || totalPages === 0
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => nextPage()}
                    >
                      Próxima
                      <i
                        style={{ marginLeft: 5 }}
                        className="fas fa-chevron-right"
                      ></i>
                    </Button>
                  </div>
                ) : null}
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <Modal
        open={openModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <NovoCertificado
          modelosCertificados={modelosCertificados}
          recarregarCertificados={getCertificados}
          closeModal={() => setOpenModal(false)}
        />
      </Modal>
    </Container>
  );
}
